import { Waves } from "lucide-react";

export function Logo({ compact = false }: { compact?: boolean }) {
  return (
    <div className="logo" aria-label="LingoSound">
      <span className="logo-mark"><Waves size={compact ? 19 : 23} strokeWidth={2.6} /></span>
      <span className={compact ? "logo-text compact" : "logo-text"}>Lingo<span>Sound</span></span>
    </div>
  );
}
